import Icon from '@ant-design/icons';

const NdeDistressingSvg = () => (
  <svg width="1.1em" height="1.1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" fill="currentColor">
    <g>
      <path d="M601.2,598.8c-1.7-1.8-41.4-40.6-127-60.1c4-6.7,7.4-13.9,9.9-21.3h5.9c19.3,0,35-15.7,35-35s-15.7-35-35-35V465
		c9.7,0,17.5,7.8,17.5,17.5S499.7,500,490,500h-1.6c1-5.7,1.6-11.5,1.6-17.5h-17.5c0,57.9-54.9,105-122.5,105s-122.5-47.1-122.5-105
		H210c0,6,0.6,11.8,1.6,17.5H210c-9.7,0-17.5-7.8-17.5-17.5S200.4,465,210,465v-17.5c-19.3,0-35,15.7-35,35s15.7,35,35,35h5.9
		c2.5,7.4,5.9,14.5,9.9,21.3c-85.6,19.5-125.2,58.3-127,60.1l12.4,12.4c0.4-0.4,40-39,125.7-56.8C262.3,585,303.5,605,350,605
		s87.7-20,113.2-50.7c85.2,17.8,125.3,56.5,125.7,56.9L601.2,598.8z"/>
      <path d="M323.8,482.5c0,14.5,11.8,26.2,26.2,26.2c14.5,0,26.3-11.8,26.3-26.2v-35h-17.5v35c0,4.8-3.9,8.8-8.8,8.8
		c-4.8,0-8.7-3.9-8.7-8.8v-35h-17.5V482.5z"/>
      <path d="M312.4,453.7L300,441.3c-19.3,19.3-38.1,2-40.2,0l-12.3,12.4c6.6,6.6,19,14.3,33.4,14.3C290.9,468,301.9,464.2,312.4,453.7
		L312.4,453.7z"/>
      <path d="M452.4,453.7L440,441.3c-19.3,19.3-38.1,2-40.2,0l-12.3,12.4c6.6,6.6,19,14.3,33.4,14.3C430.9,468,441.9,464.2,452.4,453.7
		L452.4,453.7z"/>
      <path d="M396.9,561.2l11.2-13.5c-0.6-0.5-58.8-47.9-116.2,0l11.2,13.4C349.2,522.7,395,559.6,396.9,561.2L396.9,561.2z"/>
      <path d="M461.2,348.7c3.4-3.4,3.4-9,0-12.4s-9-3.4-12.4,0l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6
		L461.2,348.7z"/>
      <path d="M396.3,336.3l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4
		C405.3,332.9,399.7,332.9,396.3,336.3z"/>
      <path d="M343.8,336.3l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4
		C352.8,332.9,347.2,332.9,343.8,336.3z"/>
      <path d="M291.3,336.3l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4
		C300.3,332.9,294.7,332.9,291.3,336.3z"/>
      <path d="M251.2,336.3c-3.4-3.4-9-3.4-12.4,0l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8
		C254.6,345.3,254.6,339.7,251.2,336.3L251.2,336.3z"/>
      <path d="M463.8,395c2.2,0,4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4s-9-3.4-12.4,0l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4
		C459.3,394.1,461.5,395,463.8,395L463.8,395z"/>
      <path d="M405.1,392.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4s-9-3.4-12.4,0l-8.8,8.8
		C401.6,383.5,401.6,389,405.1,392.4L405.1,392.4z"/>
      <path d="M352.6,392.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4s-9-3.4-12.4,0l-8.8,8.8
		C349.1,383.5,349.1,389,352.6,392.4L352.6,392.4z"/>
      <path d="M308.8,371.3l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6s4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4
		C317.8,367.9,312.2,367.9,308.8,371.3z"/>
      <path d="M253.8,395c2.2,0,4.5-0.9,6.2-2.6l8.8-8.8c3.4-3.4,3.4-9,0-12.4s-9-3.4-12.4,0l-8.8,8.8c-3.4,3.4-3.4,9,0,12.4
		C249.3,394.1,251.5,395,253.8,395L253.8,395z"/>
      <path d="M245,325v-0.4c10,0.4,48.5,0.4,210,0.4c29,0,52.5-23.6,52.5-52.5c0-27-20.6-49.4-46.8-52.2
		c-11.8-50.2-56.9-87.8-110.7-87.8c-60.1,0-109.4,46.8-113.5,105.8c-20.1,4-35.3,21.7-35.3,42.9C201.3,305.4,220.9,325,245,325
		L245,325z M245,255h8.8v-8.8c0-53.1,43.2-96.2,96.2-96.2s96.2,43.2,96.2,96.2v8.8h17.5v-8.8c0-2.6-0.2-5.1-0.4-7.6
		c15.3,3.8,26.6,17.5,26.6,33.9c0,19.3-15.7,35-35,35H245c-14.5,0-26.2-11.8-26.2-26.2C218.8,266.9,230.5,255,245,255L245,255z"/>
    </g>
  </svg>
);

export const NdeDistressingIcon = props => <Icon component={NdeDistressingSvg} {...props} />;
